/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_FooterInputs */

const id_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semoga Force (dan bata LEGO) menyertai Anda! 🧱✨`)
};

const ms_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semoga Force (dan blok LEGO) bersama anda! 🧱✨`)
};

const da_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Må Kraften (og LEGO-klodserne) være med dig! 🧱✨`)
};

const de_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möge die Macht (und die LEGO-Steine) mit Ihnen sein! 🧱✨`)
};

const en_us2_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May the Force (and LEGO bricks) be with you! 🧱✨`)
};

const es_es2_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Que la Fuerza (y los ladrillos LEGO) te acompañen! 🧱✨`)
};

const es_mx2_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Que la Fuerza (y los ladrillos LEGO) te acompañen! 🧱✨`)
};

const fil_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nawa'y sumainyo ang Force (at LEGO bricks)! 🧱✨`)
};

const fr_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que la Force (et les briques LEGO) soient avec vous ! 🧱✨`)
};

const it_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che la Forza (e i mattoncini LEGO) siano con te! 🧱✨`)
};

const hu_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legyen veled az Erő (és a LEGO kockák)! 🧱✨`)
};

const nl_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moge de Force (en LEGO-stenen) met je zijn! 🧱✨`)
};

const no_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Må Kraften (og LEGO-klossene) være med deg! 🧱✨`)
};

const pl_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niech Moc (i klocki LEGO) będzie z tobą! 🧱✨`)
};

const pt_br2_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que a Força (e os tijolos LEGO) estejam com você! 🧱✨`)
};

const pt_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que a Força (e os tijolos LEGO) esteja consigo! 🧱✨`)
};

const ro_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fie ca Forța (și cărămizile LEGO) să fie cu tine! 🧱✨`)
};

const fi_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olkoon Voima (ja LEGO-palikat) kanssasi! 🧱✨`)
};

const sv_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Må Kraften (och LEGO-klossarna) vara med dig! 🧱✨`)
};

const vi_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cầu mong Thần lực (và gạch LEGO) ở bên bạn! 🧱✨`)
};

const tr_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güç (ve LEGO tuğlaları) sizinle olsun! 🧱✨`)
};

const cs_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ať je Síla (a LEGO kostky) s vámi! 🧱✨`)
};

const bg_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нека Силата (и LEGO тухлите) бъде с вас! 🧱✨`)
};

const ru_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да пребудет с вами Сила (и кирпичики LEGO)! 🧱✨`)
};

const uk_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нехай Сила (і цеглинки LEGO) буде з вами! 🧱✨`)
};

const ar_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لتكن القوة (ومكعبات LEGO) معك! 🧱✨`)
};

const hi_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोर्स आपके साथ हो! 🧱✨`)
};

const th_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขอให้พลัง (และอิฐ LEGO) จงอยู่กับคุณ! 🧱✨`)
};

const ja_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォース（と LEGO ブロック）があなたとともにありますように！🧱✨`)
};

const zh_cn2_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`愿原力（和乐高积木）与您同在！🧱✨`)
};

const zh_hant1_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`願原力（和樂高積木）與您同在！🧱✨`)
};

const ko_misc_posts_footer = /** @type {(inputs: Misc_Posts_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force(와 LEGO 브릭)가 함께 하길! 🧱✨`)
};

/**
* | output |
* | --- |
* | "May the Force (and LEGO bricks) be with you! 🧱✨" |
*
* @param {Misc_Posts_FooterInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_footer = /** @type {((inputs?: Misc_Posts_FooterInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_FooterInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_footer(inputs)
	if (locale === "ms") return ms_misc_posts_footer(inputs)
	if (locale === "da") return da_misc_posts_footer(inputs)
	if (locale === "de") return de_misc_posts_footer(inputs)
	if (locale === "en-US") return en_us2_misc_posts_footer(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_footer(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_footer(inputs)
	if (locale === "fil") return fil_misc_posts_footer(inputs)
	if (locale === "fr") return fr_misc_posts_footer(inputs)
	if (locale === "it") return it_misc_posts_footer(inputs)
	if (locale === "hu") return hu_misc_posts_footer(inputs)
	if (locale === "nl") return nl_misc_posts_footer(inputs)
	if (locale === "no") return no_misc_posts_footer(inputs)
	if (locale === "pl") return pl_misc_posts_footer(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_footer(inputs)
	if (locale === "pt") return pt_misc_posts_footer(inputs)
	if (locale === "ro") return ro_misc_posts_footer(inputs)
	if (locale === "fi") return fi_misc_posts_footer(inputs)
	if (locale === "sv") return sv_misc_posts_footer(inputs)
	if (locale === "vi") return vi_misc_posts_footer(inputs)
	if (locale === "tr") return tr_misc_posts_footer(inputs)
	if (locale === "cs") return cs_misc_posts_footer(inputs)
	if (locale === "bg") return bg_misc_posts_footer(inputs)
	if (locale === "ru") return ru_misc_posts_footer(inputs)
	if (locale === "uk") return uk_misc_posts_footer(inputs)
	if (locale === "ar") return ar_misc_posts_footer(inputs)
	if (locale === "hi") return hi_misc_posts_footer(inputs)
	if (locale === "th") return th_misc_posts_footer(inputs)
	if (locale === "ja") return ja_misc_posts_footer(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_footer(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_footer(inputs)
	return ko_misc_posts_footer(inputs)
});
export { misc_posts_footer as "misc.posts.footer" }